module.exports = __webpack_public_path__ + "img/TreeFakerLogo.4983e02e.svg";